import { adminHttpClient } from '../../commons/adminHttpClient'
import localStorage from '../../commons/localStorage'

const wizardApi = (): Promise<any> => {
  const code = localStorage.getProspectSignupCode()
  var encodedCode = encodeURIComponent(code ?? '')
  return adminHttpClient.get(`/IchraDecisionTool/ProspectApplication/Wizard?code=${encodedCode}`)
}

export default wizardApi
